import { pushAPI } from './api';

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    // Register (or update) the service worker — do NOT unregister existing ones
    // Unregistering destroys push subscriptions tied to that registration
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
      updateViaCache: 'none',
    });
    // Trigger an update check (downloads new SW if changed)
    registration.update().catch(() => {});
    return registration;
  } catch (err) {
    console.warn('SW registration failed:', err);
    return null;
  }
}

export async function subscribeToPush() {
  try {
    const registration = await navigator.serviceWorker.ready;

    // Check for existing subscription first
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      // Need to create a new subscription
      const { data } = await pushAPI.getVapidKey();
      const publicKey = data.public_key;
      if (!publicKey) {
        console.warn('No VAPID public key from server');
        return null;
      }

      const applicationServerKey = urlBase64ToUint8Array(publicKey);
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
      });
    }

    // Always sync subscription to backend (idempotent upsert)
    await pushAPI.subscribe({
      endpoint: subscription.endpoint,
      keys: subscription.toJSON().keys,
    });

    return subscription;
  } catch (err) {
    console.warn('Push subscription failed:', err);
    return null;
  }
}

export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await pushAPI.unsubscribe({ endpoint: subscription.endpoint, keys: subscription.toJSON().keys });
      await subscription.unsubscribe();
    }
  } catch (err) {
    console.warn('Push unsubscribe failed:', err);
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
